import type { FieldValidator, PrimitiveField, ValidationError } from '@adv-frontend/form-kit';

type Primitive = string | number | boolean | null;

export function phoneValidator<
    Code extends string,
    FieldValue extends Primitive,
    FieldContextInput,
    FieldContext,
    FieldActions,
    FieldSelectors,
>(
    code: Code
): FieldValidator<
    PrimitiveField<FieldValue, ValidationError<Code>, FieldContextInput, FieldContext, FieldActions, FieldSelectors>
> {
    return (value, fieldApi) => {
        const phoneRegExp = /^(8|\+7)(\d){10}$/gi;

        if (value && !phoneRegExp.test(value.toString())) {
            fieldApi.addValidationError({ code });
        }
    };
}
